/* eslint-disable no-unused-vars */
class SmartlookMock {
    static init() {
        // @ts-expect-error TS2339: Property smartlook does not exist on type Window & typeof globalThis
        window.smartlook = (functionName, ...args) => void 0; //SmartlookMock[functionName](...args);
    }
}
SmartlookMock.identify = (userId, props) => void 0;
SmartlookMock.anonymize = () => void 0;
SmartlookMock.track = (eventName, props) => void 0;
SmartlookMock.disable = () => void 0;
SmartlookMock.consentForms = (consent) => void 0;
SmartlookMock.consentIP = (consent) => void 0;
SmartlookMock.consentAPI = (consent) => void 0;
SmartlookMock.getData = (callback = () => void 0) => void 0;
SmartlookMock.restart = () => void 0;
SmartlookMock.pause = () => void 0;
SmartlookMock.resume = () => void 0;
SmartlookMock.error = (error) => void 0;
SmartlookMock.navigation = (locationOrPath) => void 0;
export default SmartlookMock;
